import moment from "moment";
import { FormatFunction } from "PFCore/helpers/date_formatter";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { useState } from "react";
import { TFunction } from "react-i18next";

type AvailabilityRangeOption = {
  id: string;
  item: { start: string; end: string };
  displayElement: string;
};

export const useAvailabilityRangeOptions = (formatISODate: FormatFunction, t: TFunction) => {
  const {
    data: { availability }
  } = useMyAccountInfo();

  const availabilityMatchMonthsLimit = availability?.match_months_limit;

  const [options] = useState<AvailabilityRangeOption[]>(() => {
    const availabilityFromToday = (number: number, unit: moment.unitOfTime.DurationConstructor) => ({
      start: formatISODate(),
      end: formatISODate(moment().add(number, unit))
    });

    return [
      {
        id: "week",
        item: availabilityFromToday(1, "weeks"),
        displayElement: t("calendar.ranges.nextNWeeks", { count: 1 })
      },
      {
        id: "two_weeks",
        item: availabilityFromToday(2, "weeks"),
        displayElement: t("calendar.ranges.nextNWeeks", { count: 2 })
      },
      {
        id: "one_month",
        item: availabilityFromToday(1, "months"),
        displayElement: t("calendar.ranges.nextNMonths", { count: 1 })
      },
      {
        id: "two_months",
        item: availabilityFromToday(2, "months"),
        displayElement: t("calendar.ranges.nextNMonths", { count: 2 })
      },
      {
        id: "six_months",
        item: availabilityFromToday(6, "months"),
        displayElement: t("calendar.ranges.nextNMonths", { count: 6 })
      }
    ];
  });

  return { options, availabilityMatchMonthsLimit };
};
